<footer class="px-20px md:px-32px mx-auto pt-80px pb-40px">
  <div class="logo-wrapper">
    <div class="inline-flex" [inlineSVG]="'assets/images/footer-logo.svg'"></div>
  </div>
  <div class="footer-content grid grid-cols-12 gap-x-12px p-32px md:px-20px md:pt-40px md:pb-20px bg-base-sand" [class.bg-base-white]="altBackground">
    <div class="category col-span-12 md:col-span-4 lg:col-span-2 mb-36px">
      <p class="mb-16px">
        <a [routerLink]="['/systems']" routerLinkActive="active">{{ 'FOOTER.SYSTEMS.CATEGORY_TITLE' | translate }}</a>
      </p>
      @for (system of (systems$ | async)?.data; track system.slug) {
        <a [routerLink]="['/systems', system.slug]" routerLinkActive="active">{{ system.title }}</a>
      }
      <a [routerLink]="['/systems']" [fragment]="'benefits'" routerLinkActive="active">{{ 'FOOTER.SYSTEMS.BENEFITS' | translate }}</a>
    </div>
    <div class="category col-span-12 md:col-span-4 lg:col-span-2 mb-36px">
      <p class="mb-16px">
        <a [routerLink]="['/reagents']" [fragment]="'collection'" routerLinkActive="active">{{ 'FOOTER.REAGENTS.CATEGORY_TITLE' | translate }}</a>
      </p>
      <a [routerLink]="['/reagents']" [fragment]="'collection'" routerLinkActive="active">{{ 'FOOTER.REAGENTS.COLLECTION' | translate }}</a>
      <a [routerLink]="['/reagents']" [fragment]="'benefits'" routerLinkActive="active">{{ 'FOOTER.REAGENTS.BENEFITS' | translate }}</a>
    </div>
    <div class="category col-span-12 md:col-span-4 lg:col-span-2 mb-36px">
      <p class="mb-16px">
        <a [routerLink]="['/company']" routerLinkActive="active">{{ 'FOOTER.COMPANY.CATEGORY_TITLE' | translate }}</a>
      </p>
      <a [routerLink]="['/company']" fragment="mission" routerLinkActive="active">{{ 'FOOTER.COMPANY.MISSION' | translate }}</a>
      <a [routerLink]="['/company']" fragment="history" routerLinkActive="active">{{ 'FOOTER.COMPANY.HISTORY' | translate }}</a>
      <a [routerLink]="['/company']" fragment="team" routerLinkActive="active">{{ 'FOOTER.COMPANY.TEAM' | translate }}</a>
    </div>
    <div class="category col-span-12 md:col-span-4 lg:col-span-2 mb-36px">
      <p class="mb-16px">
        <a [routerLink]="['/support']" routerLinkActive="active">{{ 'FOOTER.SUPPORT.CATEGORY_TITLE' | translate }}</a>
      </p>
      <a [routerLink]="['/product-archive']" routerLinkActive="active">{{ 'FOOTER.SUPPORT.PRODUCT_ARCHIVE' | translate }}</a>
      <a [routerLink]="['/support']" fragment="faq" routerLinkActive="active">{{ 'FOOTER.SUPPORT.FAQ' | translate }}</a>
    </div>
    <div class="category col-span-12 md:col-span-4 lg:col-span-2 mb-36px">
      <p class="mb-16px">
        <a [routerLink]="['/jobs']" routerLinkActive="active">{{ 'FOOTER.JOBS.CATEGORY_TITLE' | translate }}</a>
      </p>
      <a [routerLink]="['/jobs']" fragment="openings" routerLinkActive="active">{{ 'FOOTER.JOBS.JOBS' | translate }}</a>
    </div>
    <div class="category col-span-12 md:col-span-4 lg:col-span-2 mb-36px">
      <p class="mb-16px">
        <a [routerLink]="['/contact']" routerLinkActive="active">{{ 'FOOTER.CONTACT.CATEGORY_TITLE' | translate }}</a>
      </p>
      <a [routerLink]="['/contact']" fragment="contactform" routerLinkActive="active">{{ 'FOOTER.CONTACT.REQUEST' | translate }}</a>
    </div>
    <div class="copyright-container col-span-12">
      <div class="flex w-full justify-between flex-col-reverse md:flex-row gap-y-32px">
        <span class="whitespace-nowrap leading-[32px]">{{ 'FOOTER.COPYRIGHT' | translate: {currentYear: date | date: 'yyyy'} }}</span>
        <div class="legal-links flex flex-col md:flex-row">
          <a class="py-4px md:ml-32px" [routerLink]="['/legal-notice']" routerLinkActive="active">{{ 'FOOTER.LEGAL.LEGAL_NOTICE' | translate }}</a>
          <a class="py-4px md:ml-32px" [routerLink]="['/terms-and-conditions']" routerLinkActive="active">{{ 'FOOTER.LEGAL.TERMS_AND_CONDITIONS' | translate }}</a>
          <a class="py-4px md:ml-32px" [routerLink]="['/privacy-policy']" routerLinkActive="active">{{ 'FOOTER.LEGAL.PRIVACY_POLICY' | translate }}</a>
          <a class="py-4px md:ml-32px" href="//www.linkedin.com/company/gerbion/" target="_blank">{{ 'FOOTER.CONNECT.LINKED_IN' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</footer>
